import {Component, Input, OnInit} from '@angular/core';
import {InputBase} from '../input-base';
import {FormControl} from '@angular/forms';

@Component({
  selector: 'cmp-input',
  template: `<label class="m-1" *ngIf="_label">{{_label}}</label>

<!--INPUT BY MODEL-->

<input [type]="_type"
       *ngIf="!control"
       [maxlength]="_maxlenght || null"
       [minlength]="_minlength || null"
       [class]="classCustom"
       [(ngModel)]="model"
       [name]="name || null"
       (ngModelChange)="outputModel()"
       [disabled]="isDisabled || null"
       [id]="nameId"
       [placeholder]="_placeholder">
<!--INPUT BY CONTROL-->
<input [type]="_type"
       *ngIf="control"
       [maxlength]="_maxlenght || null"
       [minlength]="_minlength || null"
       [class]="classCustom"
       [formControl]="control"
       [class.is-valid]="control.valid "
       [name]="name || null"
       [class.is-invalid]="!control.valid  && (control.dirty || control.touched)"
       (ngModelChange)="outputModel()"
       [disabled]="isDisabled || null"
       [id]="nameId"
       [placeholder]="_placeholder">
<small *ngIf="(textDetail && viewTextDetail ) || viewMesageDinamicValidation"
       class="form-text text-center text-{{colorTextDetail}}">{{textDetail}}
</small>
`,
  styles: [`.form-control-xs{height:27px;font-size:14px;padding-left:5px}`]
})
export class InputTextComponent extends InputBase implements OnInit {

  @Input() control: FormControl;

  constructor() {
    super();
  }

  ngOnInit() {
  }

  get classCustom() {
    let retorno = 'form-control form-control-sm ';
    if (this.onClass) {
      retorno += this.onClass;
    }
    return retorno;
  }
}
